import { getFullComposeViewState } from 'owa-calendar-compose-store-manager';
import { mutator } from 'satcheljs';
import { updateCharmSelection } from 'owa-calendar-compose-form-actions';

export default mutator(updateCharmSelection, actionMessage => {
    let storeViewState = getFullComposeViewState(actionMessage.formId);
    if (storeViewState) {
        storeViewState.isCharmExplicitlySet = actionMessage.explicitlySet;
    }
});
